import React, { useContext, Fragment } from 'react'
import { Typography } from '@material-ui/core'
import moment from 'moment'
import DatePickerRange from '../../../../components/filters/DatePickerRange'
import { PharmaciesFiltersContext } from '../../../../context/PharmaciesFiltersContext'
import { defaultFormatTimeZone } from '../../../../utils/consts'

export default function DateRange (): JSX.Element {
  const { filters, setFilters } = useContext(PharmaciesFiltersContext)
  const onChange = (initialDate: moment.Moment, finalDate: moment.Moment) => {
    setFilters({
      createdAt: {
        initialDate: initialDate.format('YYYY-MM-DD'),
        finalDate: finalDate.format('YYYY-MM-DD'),
        ...defaultFormatTimeZone
      }
    })
  }

  return (
    <Fragment>
      <Typography id="discrete-slider-custom" gutterBottom>Período</Typography>
      <DatePickerRange
        defaultInitialValue={moment(filters.createdAt?.initialDate)}
        defaultFinalValue={moment(filters.createdAt?.finalDate)}
        onChange={onChange}
      />
    </Fragment>
  )
}
